import { useState } from "react";
import AbstractPermissions from "../modules/Auth/AbstractPermission";

export default function usePermissionBag() {
    const [permissionBag] = useState(AbstractPermissions.LoadFromToken())
    return permissionBag
}